export default "__VITE_ASSET__6ab6a37b__"